import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: François Risoud
 * id D8707612-8DFB-4F83-9FAE-2058254A651F
 * name lock-open-alert
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-alert.svg
 * tags
 * - Alert / Error 
 * - Home Automation 
 * - Lock 
 */
export const LockOpenAlertIcon = createSvgIcon(<><path d="M16 8C17.1 8 18 8.9 18 10V20C18 21.1 17.1 22 16 22H4C2.9 22 2 21.1 2 20V10C2 8.9 2.9 8 4 8H13V6C13 4.3 11.7 3 10 3S7 4.3 7 6H5C5 3.2 7.2 1 10 1S15 3.2 15 6V8H16M10 17C11.1 17 12 16.1 12 15S11.1 13 10 13 8 13.9 8 15 8.9 17 10 17M22 13H20V7H22V13M22 17H20V15H22V17Z" /></>, 'LockOpenAlertIcon');
export default LockOpenAlertIcon